import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { agentApi } from 'components/AIAgent/api/agent.api';
import { issuesApi } from 'components/issues/api/issues.api';

import configuration from './reducers/configuration';
import localization from './reducers/localization';
import user from './reducers/userSlice';

const rootReducer = combineReducers({
  [configuration.name]: configuration.reducer,
  [localization.name]: localization.reducer,
  [user.name]: user.reducer,
  [issuesApi.reducerPath]: issuesApi.reducer,
  [agentApi.reducerPath]: agentApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(issuesApi.middleware, agentApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
